import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function PourquoiTot() {
  const { t } = useTranslation('blogsignes');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="pourquoi-tot" className="scroll-mt-28">
      <div
        className={`bg-slate-primary rounded-xl p-6 md:p-8 text-white transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-copper shrink-0 mt-1">
            <i className="ri-alarm-warning-line text-white text-lg" />
          </div>
          <h2 className="font-manrope font-bold text-xl md:text-2xl lg:text-3xl">
            {t('tot_h2')}
          </h2>
        </div>

        <p className="text-white/80 text-base md:text-lg leading-relaxed mb-4">{t('tot_p1')}</p>
        <p className="text-white/80 text-base md:text-lg leading-relaxed mb-4">{t('tot_p2')}</p>
        <p className="text-white/90 text-base md:text-lg leading-relaxed font-medium">{t('tot_p3')}</p>
      </div>
    </section>
  );
}